// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { EmbeddedVectorMeta } from "./EmbeddedVectorMeta";
import {
  EmbeddedVectorMetaFromJSON,
  EmbeddedVectorMetaFromJSONTyped,
  EmbeddedVectorMetaToJSON,
  EmbeddedVectorMetaToJSONTyped,
} from "./EmbeddedVectorMeta";
import type { User } from "./User";
import { UserFromJSON, UserFromJSONTyped, UserToJSON, UserToJSONTyped } from "./User";
import type { FileReadWithUrl } from "./FileReadWithUrl";
import {
  FileReadWithUrlFromJSON,
  FileReadWithUrlFromJSONTyped,
  FileReadWithUrlToJSON,
  FileReadWithUrlToJSONTyped,
} from "./FileReadWithUrl";
import type { PublicationVersionDescriptor } from "./PublicationVersionDescriptor";
import {
  PublicationVersionDescriptorFromJSON,
  PublicationVersionDescriptorFromJSONTyped,
  PublicationVersionDescriptorToJSON,
  PublicationVersionDescriptorToJSONTyped,
} from "./PublicationVersionDescriptor";
import type { Directory } from "./Directory";
import {
  DirectoryFromJSON,
  DirectoryFromJSONTyped,
  DirectoryToJSON,
  DirectoryToJSONTyped,
} from "./Directory";

/**
 *
 * @export
 * @interface ItemsInner
 */
export interface ItemsInner {
  /**
   *
   */
  type?: ItemsInnerTypeEnum;
  /**
   *
   */
  id: string;
  /**
   *
   */
  lastModified: Date;
  /**
   *
   */
  size: number;
  /**
   *
   */
  etag: string;
  /**
   *
   */
  user: User;
  /**
   *
   */
  mediaType: string;
  /**
   *
   */
  descriptorId: string;
  /**
   *
   */
  descriptor: PublicationVersionDescriptor;
  /**
   * This field is null when the file has not yet been identified.
   */
  dataType?: string;
  /**
   *
   */
  url: string;
  /**
   *
   */
  meta?: EmbeddedVectorMeta;
}

/**
 * @export
 */
export const ItemsInnerTypeEnum = {
  File: "file",
  Directory: "directory",
} as const;
export type ItemsInnerTypeEnum = (typeof ItemsInnerTypeEnum)[keyof typeof ItemsInnerTypeEnum];

/**
 * Check if a given object implements the ItemsInner interface.
 */
export function instanceOfItemsInner(value: object): value is ItemsInner {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (
    (!("lastModified" in (value as Record<string, any>)) &&
      !("last_modified" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["lastModified"] === undefined &&
      (value as Record<string, any>)["last_modified"] === undefined)
  )
    return false;
  if (!("size" in value) || value["size"] === undefined) return false;
  if (!("etag" in value) || value["etag"] === undefined) return false;
  if (!("user" in value) || value["user"] === undefined) return false;
  if (
    (!("mediaType" in (value as Record<string, any>)) &&
      !("media_type" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["mediaType"] === undefined &&
      (value as Record<string, any>)["media_type"] === undefined)
  )
    return false;
  if (
    (!("descriptorId" in (value as Record<string, any>)) &&
      !("descriptor_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["descriptorId"] === undefined &&
      (value as Record<string, any>)["descriptor_id"] === undefined)
  )
    return false;
  if (!("descriptor" in value) || value["descriptor"] === undefined) return false;
  if (!("url" in value) || value["url"] === undefined) return false;
  return true;
}

export function ItemsInnerFromJSON(json: any): ItemsInner {
  return ItemsInnerFromJSONTyped(json, false);
}

export function ItemsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ItemsInner {
  if (json == null) {
    return json;
  }
  return {
    type: json["type"] == null ? undefined : json["type"],
    id: json["id"],
    lastModified:
      json["last_modified"] == null ? json["last_modified"] : parseDateTime(json["last_modified"]),
    size: json["size"],
    etag: json["etag"],
    user: UserFromJSON(json["user"]),
    mediaType: json["media_type"],
    descriptorId: json["descriptor_id"],
    descriptor: PublicationVersionDescriptorFromJSON(json["descriptor"]),
    dataType: json["data_type"] == null ? undefined : json["data_type"],
    url: json["url"],
    meta: json["meta"] == null ? undefined : EmbeddedVectorMetaFromJSON(json["meta"]),
  };
}

export function ItemsInnerToJSON(json: any): ItemsInner {
  return ItemsInnerToJSONTyped(json, false);
}

export function ItemsInnerToJSONTyped(
  value?: ItemsInner | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    type: value["type"],
    id: value["id"],
    last_modified:
      value["lastModified"] == null
        ? value["lastModified"]
        : serializeDateTime(value["lastModified"]),
    size: value["size"],
    etag: value["etag"],
    user: UserToJSON(value["user"]),
    media_type: value["mediaType"],
    descriptor_id: value["descriptorId"],
    descriptor: PublicationVersionDescriptorToJSON(value["descriptor"]),
    data_type: value["dataType"],
    url: value["url"],
    meta: EmbeddedVectorMetaToJSON(value["meta"]),
  };
}
